<template>
  <div>
    <spinner v-if="isLoading" />
    <hide v-if="isHidden" />
    <canvas id="myCanvas"></canvas>
    <!-- Menú -->
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-nav>
        <b-nav-item v-b-toggle.sidebar-1 @click.prevent class="d-md-none">
          <span class="text-white">
            <b-icon-list variant="bg-black"></b-icon-list> {{ var196 }}
          </span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="mx-auto">
        <h3 style="font-size:2vw;" class="text-white"></h3>
      </b-navbar-nav>
    </b-navbar>
    <!-- SideNav -->
    <b-sidebar
      v-model="showSidebar"
      id="sidebar-1"
      :title="var196"
      shadow
      bg-variant="white"
    >
      <b-row>
        <b-col>
          <hr v-if="subnet != 'icha'" class="w-100" />
          <h5 v-if="subnet != 'icha'" class="ml-3">
            {{ var197 }}
          </h5>
          <hr v-if="subnet != 'icha'" class="w-100" />
          <b-container>
            <b-row>
              <b-col>
                <p class="mb-1 text-center text-sm">
                  {{ var204 }} {{ userProgress }} {{ var205 }} {{ valueProgress }}
                  {{ var206 }}
                </p>
                <b-progress :max="100" :variant="colorBar" height="2rem">
                  <b-progress-bar :value="userpct">
                    <strong> {{ Math.floor(userpct) }}%</strong>
                  </b-progress-bar>
                  <div v-if="userpct <= 80">
                    <b-progress-bar
                      :max="100"
                      :value="pctActivo - userpct"
                      variant="secondary"
                    >
                      <strong>
                        {{ pctActivo - userpct }}%</strong
                      ></b-progress-bar
                    >
                  </div>
                </b-progress>
              </b-col>
            </b-row>
          </b-container>
          <!-- Descarga de constancias -->
          <p class="mb-1 text-center text-sm">
            {{ mensajeConstancia }}
          </p>
          <div v-if="isContancia">
            <div>
              <b-col>
                <b-button
                  variant="danger"
                  class="mb-3 w-100"
                  block
                  @click.prevent="download()"
                >
                  {{ var198 }}
                </b-button>
              </b-col>
            </div>
          </div>
        </b-col>
      </b-row>
      <hr v-if="subnet != 'icha'" class="w-100" />
      <h4 class="ml-3">{{ var199 }}</h4>
      <!-- Mobile -->
      <!-- GrandParents -->
      <b-list-group class="mb-4">
        <div v-for="grandparent in orderedTree" :key="grandparent.id">
          <b-list-group-item
            :id="grandparent.id"
            button
            v-b-toggle="`collapse-${grandparent.id}`"
            class="w-100"
            @click="selectTema(grandparent.id)"
            :variant="!grandparent.STATUS ? 'success' : ''"
          >
            <b-icon-plus v-if="grandparent.parents.length > 0" />
            {{ grandparent.TEMA }}
            <span>
              <b-icon-check v-if="!grandparent.STATUS" />
              <span v-else>
                <br />
                <b-icon-camera-video />
                <small> {{ grandparent.TIEMPO }} mins</small>
              </span>
            </span>
          </b-list-group-item>
          <b-collapse :id="`collapse-${grandparent.id}`">
            <!-- Parents -->
            <b-list-group>
              <div v-for="parent in grandparent.parents" :key="parent.id">
                <b-list-group-item
                  button
                  :id="parent.id"
                  v-b-toggle="`collapse-${parent.id}`"
                  class="w-100"
                  @click="selectTema(parent.id)"
                  :variant="!parent.STATUS ? 'success' : ''"
                >
                  <span class="ml-3">
                    <b-icon-plus v-if="parent.childrens.length > 0" />
                    {{ parent.NIVEL1 }}
                    <span>
                      <b-icon-check v-if="parent.STATUS === false" />
                      <span v-else>
                        <br />
                        <b-icon-camera-video />
                        <small> {{ parent.TIEMPO }} mins</small>
                      </span>
                    </span>
                  </span>
                </b-list-group-item>
                <!-- Childrens -->
                <b-collapse :id="`collapse-${parent.id}`">
                  <b-list-group>
                    <div
                      v-for="children in parent.childrens"
                      :key="children.id"
                    >
                      <b-list-group-item
                        button
                        :id="children.id"
                        v-b-toggle="`collapse-${children.id}`"
                        class="w-100"
                        @click="selectTema(children.id)"
                        :variant="!children.STATUS ? 'success' : ''"
                      >
                        <span class="ml-3">
                          <span class="ml-3">
                            <b-icon-plus
                              v-if="children.grandChildrens.length > 0"
                            />
                            {{ children.NIVEL2 }}
                            <span>
                              <b-icon-check v-if="!children.STATUS" />
                              <span v-else>
                                <br />
                                <span class="ml-3">
                                  <span class="ml-3">
                                    <b-icon-camera-video />
                                    <small> {{ children.TIEMPO }} mins</small>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </b-list-group-item>
                      <b-collapse :id="`collapse-${children.id}`">
                        <b-list-group>
                          <div
                            v-for="grandchildren in children.grandChildrens"
                            :key="grandchildren.id"
                            class="p-2"
                          >
                            <b-list-group-item
                              :id="grandchildren.id"
                              button
                              @click="selectTema(grandchildren.id)"
                              :variant="!grandchildren.STATUS ? 'success' : ''"
                            >
                              <span class="ml-3">
                                <span class="ml-3">
                                  <span class="ml-3">
                                    {{ grandchildren.NIVEL3 }}
                                    <span>
                                      <b-icon-check
                                        v-if="!grandchildren.STATUS"
                                      />
                                      <span v-else>
                                        <br />
                                        <span class="ml-3">
                                          <span class="ml-3">
                                            <span class="ml-3">
                                              <b-icon-camera-video />
                                              <small>
                                                {{
                                                  grandchildren.TIEMPO
                                                }}
                                                mins</small
                                              >
                                            </span>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </b-list-group-item>
                          </div>
                        </b-list-group>
                      </b-collapse>
                    </div>
                  </b-list-group>
                </b-collapse>
              </div>
            </b-list-group>
          </b-collapse>
        </div>
      </b-list-group>
      <hr class="w-100" />
      <h5 class="ml-3">
        {{ var200 }}
      </h5>
      <hr class="w-100" />
      <b-container>
        <b-row>
          <b-col>
            <b-button
              variant="danger"
              class="mb-3 w-100"
              @click.prevent="returnLobby()"
            >
              <b-icon-house-door></b-icon-house-door>
              {{ var201 }}
            </b-button>
            <b-button
              variant="outline-danger"
              class="mb-3 w-100"
              @click.prevent="gotoComponente(showtelSoporte)"
            >
              <b-icon-question-circle></b-icon-question-circle>
              {{ var202 }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-sidebar>
    <!-- / Menú -->
    <b-container fluid>
      <b-row>
        <b-col
          cols="4"
          lg="3"
          xl="2"
          class="d-none d-md-block shadow px-0 pt-3 side-navbar"
        >
          <b-row>
            <b-col>
              <hr class="w-100" />
              <h5 class="ml-3">
                {{ var203 }}
              </h5>
              <hr class="w-100" />
              <p class="mb-1 text-center text-sm">
                {{ var204 }} {{ userProgress }} {{ var205 }} {{ valueProgress }}
                {{ var206 }}
              </p>
              <b-container>
                <b-row>
                  <b-col>
                    <b-progress
                      :max="100"
                      :variant="colorBar"
                      height="2rem"
                    >
                      <b-progress-bar :value="userpct">
                        <strong> {{ Math.floor(userpct) }}%</strong>
                      </b-progress-bar>
                    </b-progress>
                    <p class="mb-1 text-center text-sm">
                      {{ mensajeConstancia }}
                    </p>
                    <div v-if="isContancia">
                      <div>
                        <b-col>
                          <b-button
                            variant="danger"
                            class="mb-3 w-100"
                            @click.prevent="download()"
                          >
                            {{ var198 }}
                          </b-button>
                        </b-col>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
              <!-- Descarga de constancias -->
              <div v-if="pctTime === 100 && constancia">
                <hr style="width:100%;" v-if="subnet != 'icha'" />
                <h5 class="ml-3">
                  {{ var207 }}
                </h5>
                <hr style="width:100%;" />
                <b-container>
                  <b-row>
                    <b-col>
                      <div v-if="!mode">
                        <b-button
                          variant="success"
                          @click.prevent="download()"
                          class="w-100"
                        >
                          <b-icon-cloud-download></b-icon-cloud-download>
                          {{ var208 }}
                        </b-button>
                      </div>
                      <div v-else>
                        <div v-if="pctAns >= pctmin">
                          <b-button
                            variant="success"
                            @click.prevent="download()"
                            class="w-100"
                          >
                            <b-icon-cloud-download></b-icon-cloud-download>
                            {{ var208 }}
                          </b-button>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </b-col>
          </b-row>
          <hr class="w-100" v-if="subnet != 'icha'" />
          <h4 class="ml-3">{{ var199 }}</h4>
          <!-- Desktop -->
          <!-- GrandParents -->
          <b-list-group class="mb-4">
            <div v-for="grandparent in orderedTree" :key="grandparent.id">
              <b-list-group-item
                button
                :id="grandparent.id"
                v-b-toggle="`collapse-${grandparent.id}`"
                class="w-100"
                @click="selectTema(grandparent.id)"
                :variant="!grandparent.STATUS ? 'success' : ''"
              >
                <b-icon-plus v-if="grandparent.parents.length > 0" />
                {{ grandparent.TEMA }}
                <span>
                  <b-icon-check v-if="!grandparent.STATUS" />
                  <span v-else>
                    <br />
                    <div v-if="grandparent.TIEMPO !== '*'">
                      <b-icon-camera-video />
                      <small> {{ grandparent.TIEMPO }} mins</small>
                    </div>
                  </span>
                </span>
              </b-list-group-item>
              <b-collapse :id="`collapse-${grandparent.id}`">
                <!-- Parents -->
                <b-list-group>
                  <div v-for="parent in grandparent.parents" :key="parent.id">
                    <b-list-group-item
                      button
                      v-b-toggle="`collapse-${parent.id}`"
                      class="w-100"
                      :id="parent.id"
                      @click="selectTema(parent.id)"
                      :variant="!parent.STATUS ? 'success' : ''"
                    >
                      <span class="ml-3">
                        <b-icon-plus v-if="parent.childrens.length > 0" />
                        {{ parent.NIVEL1 }}
                        <span>
                          <b-icon-check v-if="parent.STATUS === false" />
                          <span v-else>
                            <br />
                            <div v-if="grandparent.TIEMPO !== '*'">
                              <b-icon-camera-video />
                              <small> {{ parent.TIEMPO }} mins</small>
                            </div>
                          </span>
                        </span>
                      </span>
                    </b-list-group-item>
                    <!-- Childrens -->
                    <b-collapse :id="`collapse-${parent.id}`">
                      <b-list-group>
                        <div
                          v-for="children in parent.childrens"
                          :key="children.id"
                        >
                          <b-list-group-item
                            button
                            v-b-toggle="`collapse-${children.id}`"
                            class="w-100"
                            :id="children.id"
                            @click="selectTema(children.id)"
                            :variant="!children.STATUS ? 'success' : ''"
                          >
                            <span class="ml-3">
                              <span class="ml-3">
                                <b-icon-plus
                                  v-if="children.grandChildrens.length > 0"
                                />
                                {{ children.NIVEL2 }}
                                <span>
                                  <b-icon-check v-if="!children.STATUS" />
                                  <span v-else>
                                    <br />
                                    <span class="ml-3">
                                      <span class="ml-3">
                                        <div v-if="children.TIEMPO !== '*'">
                                          <b-icon-camera-video />
                                          <small>
                                            {{ children.TIEMPO }} mins</small
                                          >
                                        </div>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </b-list-group-item>
                          <b-collapse :id="`collapse-${children.id}`">
                            <b-list-group>
                              <div
                                v-for="grandchildren in children.grandChildrens"
                                :key="grandchildren.id"
                              >
                                <b-list-group-item
                                  button
                                  :id="grandchildren.id"
                                  @click="selectTema(grandchildren.id)"
                                  :variant="
                                    !grandchildren.STATUS ? 'success' : ''
                                  "
                                >
                                  <span class="ml-3">
                                    <span class="ml-3">
                                      <span class="ml-3">
                                        {{ grandchildren.NIVEL3 }}
                                        <span>
                                          <b-icon-check
                                            v-if="!grandchildren.STATUS"
                                          />
                                          <span v-else>
                                            <br />
                                            <span class="ml-3">
                                              <span class="ml-3">
                                                <span class="ml-3">
                                                  <div
                                                    v-if="
                                                      grandchildren.TIEMPO !==
                                                        '*'
                                                    "
                                                  >
                                                    <b-icon-camera-video />
                                                    <small>
                                                      {{
                                                        grandchildren.TIEMPO
                                                      }}
                                                      mins</small
                                                    >
                                                  </div>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </b-list-group-item>
                              </div>
                            </b-list-group>
                          </b-collapse>
                        </div>
                      </b-list-group>
                    </b-collapse>
                  </div>
                </b-list-group>
              </b-collapse>
            </div>
          </b-list-group>
          <hr class="w-100" />
          <h5 class="ml-3">
            {{ var200 }}
          </h5>
          <hr class="w-100" />
          <b-container>
            <b-row>
              <b-col>
                <b-button
                  variant="danger"
                  class="mb-3 w-100"
                  @click.prevent="returnLobby()"
                >
                  <b-icon-house-door></b-icon-house-door>
                  {{ var201 }}
                </b-button>
                <a
                  v-if="emailSoptec"
                  :href="`mailto:${emailSoptec}`"
                  target="_blank"
                  class="btn btn-outline-danger btn-sm d-block mb-3 w-100"
                  @click="gotoSoporteEmail()"
                >
                  <b-icon-question-circle></b-icon-question-circle>
                  {{ var202 }}
                </a>
                <b-button
                  v-else
                  variant="outline-danger"
                  class="mb-3 w-100"
                  @click.prevent="gotoComponente(showtelSoporte)"
                >
                  <b-icon-question-circle></b-icon-question-circle>
                  {{ var202 }}
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="12" md="8" lg="9" xl="10" class="main">
          <div class="col-12 py-3">
            <div class="img_box mb-3">
              <img
                :src="background"
                alt="E-learning"
                ref="background"
                width="100%"
                draggable="false"
                usemap="#workmap"
                @load="handleResize"
              />
              <!-- Backgraound -->

              <!-- Image map -->
              <map name="workmap">
                <area
                  v-for="(area, index) in filteredAreas"
                  :key="index"
                  :alt="area.alt"
                  :title="area.title"
                  :href="area.href"
                  :coords="area.coords"
                  shape="polygon"
                  @click.prevent="
                    goto(area.url, area.title, area.type, area.imagen)
                  "
                  @mouseover="drawHover($event)"
                  @mouseout="cleanHover()"
                  @touchend="cleanHover()"
                />
              </map>
            </div>
            <div class="preguntas">
              <div class="card bg-white shadow-lg rounded">
                <div class="card-header p-4 text-left bg-black text-black">
                  <div class="mb-3 bg-secundary ">
                    <div class="text-center">
                      <h3>
                        {{ titulo }} <br />
                        <span v-if="value.TEMA"></span>{{ value.TEMA }}
                      </h3>
                    </div>
                  </div>
                </div>
                <!-- Video -->
                <div class="card bg-ligth text-center shadow-lg rounded">
                  <div
                    v-if="!finished && value.STATUS && value.TIEMPO !== '*'"
                    class="embed-container w-100"
                  >
                    <div class="div" id="video" ref="video">
                      <vimeo-player
                        v-if="frameURL !== 'https://player.vimeo.com/41911454'"
                        ref="player"
                        :video-id="frameURL"
                        player-width="600"
                        @ready="onReady"
                        @ended="endVideo"
                        :options="{
                          keyboard: false
                        }"
                      >
                      </vimeo-player>
                    </div>
                  </div>
                  <div v-else-if="value && finished">
                    <div v-if="modeType === 'onDemand'">
                      {{ var209 }}
                      <!-- <b-button size="sm" variant="info" @click="sendQues()">
                        <b-icon-cursor></b-icon-cursor>
                        Guardar Avance</b-button> -->
                    </div>
                    <div v-else>
                      <hr />
                      <h3>
                        <b-icon-question-circle
                          variant="warning"
                        ></b-icon-question-circle>
                        {{ value.PREGUNTA }}
                      </h3>
                      <hr />
                      <b-row class="pl-md-2 pr-md-2">
                        <b-col v-if="value.ANS1 != '*'" :id="`id-${value.id}`">
                          <b-form-checkbox
                            v-if="value.ANS1 != '*'"
                            class="p-4"
                            v-model="answer"
                            :value="value.ANS1"
                            name="checkbox"
                            >{{ value.ANS1 }}
                          </b-form-checkbox>
                        </b-col>
                        <b-col v-if="value.ANS2 != '*'" :id="`id-${value.id}`">
                          <b-form-checkbox
                            v-if="value.ANS2 != '*'"
                            class="p-4"
                            v-model="answer"
                            :value="value.ANS2"
                            name="checkbox"
                            >{{ value.ANS2 }}
                          </b-form-checkbox>
                        </b-col>
                        <b-col v-if="value.ANS3 != '*'" :id="`id-${value.id}`">
                          <b-form-checkbox
                            v-if="value.ANS3 != '*'"
                            class="p-4"
                            v-model="answer"
                            :value="value.ANS3"
                            name="checkbox"
                            >{{ value.ANS3 }}
                          </b-form-checkbox>
                        </b-col>
                        <b-col v-if="value.ANS4 != '*'" :id="`id-${value.id}`">
                          <b-form-checkbox
                            v-if="value.ANS4 != '*'"
                            class="p-4"
                            v-model="answer"
                            :value="value.ANS4"
                            name="checkbox"
                            >{{ value.ANS4 }}
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-button
                        size="sm"
                        variant="info"
                        class="mb-3"
                        @click="sendQues(answer)"
                      >
                        <b-icon-cursor></b-icon-cursor>
                        {{ var210 }}</b-button
                      >
                    </div>
                  </div>
                  <!--Mensaje de seccion contestada-->
                  <div v-else-if="!value.STATUS && value">
                    <!-- Player para ver nuevamente -->
                    <div class="div" id="video" ref="video">
                      <vimeo-player
                        v-if="playAgain"
                        ref="player"
                        :video-id="value.URL"
                        player-width="600"
                        @ready="onReady"
                        @ended="endPlayAgain"
                        :options="{
                          keyboard: false
                        }"
                      >
                      </vimeo-player>
                    </div>
                    <!-- Sección contestada y botones de acción -->
                    <b-container v-if="!playAgain" fluid>
                      <b-row class="mb-1 text-center">
                        <b-col class="w-100 py-3">
                          <h4 class="text-center">
                            <b-icon
                              icon="check"
                              scale="2"
                              variant="success"
                            ></b-icon>
                            {{ var211 }}
                          </h4>
                          <br />
                          <small>{{ var212 }}</small>
                          <!-- botones de siguiente y ver de nuevo CMO2022 -->
                          <div class="actions mt-4">
                            <b-button @click="playAgain = true" variant="info">Ver nuevamente</b-button>
                            <b-button
                              :disabled="parseInt(value.id) === excelData.length"
                              @click="nextVideo(value.id)"
                              variant="success">
                              Siguiente
                            </b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>
                <div class="card-body rounded px-4">
                  <div v-if="!mode">
                    <p class="card-text px-5"></p>
                    <h4>{{ var213 }}</h4>
                    <hr class="w-100" />
                    <ol>
                      <li v-if="var214">{{ var214 }}</li>
                      <li v-if="var215">{{ var215 }}</li>
                      <li v-if="var216">{{ var216 }}</li>
                      <li v-if="var217">{{ var217 }}</li>
                      <li v-if="var218">{{ var218 }}</li>
                      <li v-if="var219">{{ var219 }}</li>
                    </ol>
                  </div>
                  <div v-else-if="pctTime < 100">
                    <p class="card-text px-5"></p>
                    <h4>{{ var213 }}</h4>
                    <ol>
                      <li>{{ var220 }}</li>
                      <li>{{ var221 }}</li>
                      <li>{{ var222 }}</li>
                      <li>{{ var223 }}</li>
                    </ol>
                  </div>
                  <div v-else>
                    <p class="card-text px-5 text-center"></p>
                    <h4>{{ var224 }}</h4>
                    {{ var225 }}<br /><br />
                    <div v-if="ansTotal === 0">
                      <b-button
                        size="sm"
                        variant="info"
                        @click="getResultado()"
                      >
                        {{ var226 }}</b-button
                      >
                    </div>
                    <div v-else-if="pctAns > pctmin">
                      {{ var227 }}<br />
                      <h3>{{ var228 }}</h3>
                      {{ var229 }} {{ pctAns }}%<br />
                      {{ var230 }} {{ pctmin }}%<br />
                      {{ var231 }}
                      <div class="p-2 ">
                        <b-button variant="success" @click.prevent="download()">
                          <b-icon-cloud-download></b-icon-cloud-download>
                          {{ var208 }}
                        </b-button>
                      </div>
                    </div>
                    <div v-else>
                      {{ var227 }}<br />
                      <h3>{{ var232 }}</h3>
                      {{ var229 }} {{ pctAns }}%<br />
                      {{ var230 }} {{ pctmin }}%<br />
                      {{ var233 }}
                    </div>
                  </div>
                </div>
                <footerIMS class="footer" />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- Modal de video -->
    <b-modal v-model="videoShow" :title="videoTitle" size="lg" hide-footer>
      <div class="w-100">
        <iframe
          :src="videoModal"
          :style="{ height: '80vh' }"
          width="100%"
          height="auto"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        />
      </div>
    </b-modal>
    <!-- Modal imagen -->
    <b-modal
      v-model="imageShow"
      :title="videoTitle"
      size="lg"
      hide-footer
      scrollable
    >
      <div class="w-100 text-center" :style="{ height: '80vh' }">
        <img class="w-100" :src="imageArea" alt="Image area" />
      </div>
    </b-modal>
    <!-- Modal document -->
    <b-modal
      v-model="pdfShow"
      :title="videoTitle"
      size="xl"
      scrollable
      hide-footer
    >
      <div class="w-100">
        <iframe :src="pdf" class="pdf" width="100%" :style="{ height: '80vh' }">
          <pdf :src="pdf"></pdf>
        </iframe>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import apiElearning from '../api/elearning'
import apiGrals from '../api/config.js'
import userActivity from '../api/userActividad.js'
import Vue from 'vue'
import vueVimeoPlayer from 'vue-vimeo-player'
import moment from 'moment'
import VTree from 'vue-vtree'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import FooterIMS from '@/components/FooterIMS'
import apiLogin from '../api/auth'
// import insertQues from '../api/preguntas'
import Spinner from '@/components/Spinner'
import Hide from '@/components/Hide'
import { bTreeView } from 'bootstrap-vue-treeview'
import swal from 'sweetalert'
import pdf from 'vue-pdf'
import {
  BButton,
  BModal,
  BContainer,
  BFormTextarea,
  BRow,
  BCol,
  BImg,
  BIcon,
  BootstrapVueIcons,
  BProgress,
  BProgressBar,
  BSidebar,
  BNavbarToggle,
  BCollapse,
  VBToggle,
  BCard,
  VBTogglePlugin,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItemButton,
  BNavbar,
  BNavbarNav,
  BNavItem,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormGroup
} from 'bootstrap-vue'
const SECRET = 'e2ab018979a3c007014c10efb3b0c3fe'
var jwt = require('jsonwebtoken')
Vue.component('v-tree', VTree)
Vue.use(BootstrapVueIcons)
Vue.use(vueVimeoPlayer)
Vue.directive('b-toggle', VBToggle)
export default {
  name: 'Elearning',
  components: {
    BButton,
    BModal,
    BContainer,
    BFormTextarea,
    BRow,
    BCol,
    Spinner,
    bTreeView,
    BImg,
    BIcon,
    BootstrapVueIcons,
    BProgress,
    BProgressBar,
    BSidebar,
    BNavbarToggle,
    BCollapse,
    VBToggle,
    BCard,
    VBTogglePlugin,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItemButton,
    BNavbar,
    BNavbarNav,
    BNavItem,
    Hide,
    FooterIMS,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormGroup,
    pdf
  },
  data () {
    return {
      // Zona de video
      videoID: '412839410',
      height: document.documentElement.clientHeight / 3,
      options: {
        muted: true,
        autoplay: true
      },
      playerReady: false,
      player: null,
      iframe: null,
      finished: false,
      answer: null,
      // Buttons
      // src: require('../assets/images/soporte_tecnico.png')
      bgImage: require('../assets/images/header2.png'),
      info: '../assets/images/info.png',
      buttonRegresar: '',
      buttonSoporteTecnico: '',
      buttonPregunta: '',
      logo: '',
      excelData: [],
      value: '',
      Arbol: [],
      isLoading: true,
      isHidden: false,
      timecreated: null,
      timeAcumulado: 0,
      timeTotal: 0,
      // Variables progressBar
      userpct: 0,
      pctActivo: '',
      userProgress: 0,
      valueProgress: 0,
      colorBar: '',
      mensajeConstancia: '',
      //
      pctTime: 0,
      titulo: null,
      id: null,
      // Get device width and height
      token: null,
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      // The following two are not used temporarily
      curWidth: '',
      curHeight: '',
      // Image map areas
      background: null,
      areas: [],
      // Image Width
      imageSize: 1920,
      // Width of the device
      previousWidth: 1920,
      translate: true,
      showtelSoporte: null,
      nombreSala: null,
      url1: null,
      url2: null,
      modalPregunta: false,
      idSala: null,
      respuestas: [],
      formModal: {
        nombre: '',
        correo: '',
        pregunta: '',
        sala: '',
        fecha: ''
      },
      variants: [
        'primary',
        'secondary',
        'success',
        'warning',
        'danger',
        'info',
        'light',
        'dark'
      ],
      headerBgVariant: 'warning',
      headerTextVariant: 'black',
      bodyBgVariant: 'light',
      bodyTextVariant: 'dark',
      footerBgVariant: 'light',
      footerTextVariant: 'dark',
      // Datos de Actividad de Usuario
      userActividad: {
        token: null,
        modulo: null,
        fecha: null,
        accion: null,
        correo: null,
        duracion: 0
      },
      /** Árbol */
      orderedTree: [],
      /** Canvas */
      hdc: null,
      showSidebar: false,
      videoTitle: '',
      videoShow: false,
      videoModal: '',
      pdfShow: false,
      pdf: '',
      imageArea: '',
      imageShow: false,
      /** Constancia */
      constancia: false,
      mode: false,
      ansTotal: 0,
      pctAns: 0,
      pctmin: 0,
      frameURL: '',
      modeType: '',
      subnet: localStorage.getItem('subnet'),
      localObservador: [],
      activo: false,
      componentes: [],
      emailSoptec: localStorage.getItem('emailSoptec') || '',
      // variables de mensajes
      mensajes: [],
      var196: null,
      var197: null,
      var198: null,
      var199: null,
      var200: null,
      var201: null,
      var202: null,
      var203: null,
      var204: null,
      var205: null,
      var206: null,
      var207: null,
      var208: null,
      var209: null,
      var210: null,
      var211: null,
      var212: null,
      var213: null,
      var214: null,
      var215: null,
      var216: null,
      var217: null,
      var218: null,
      var219: null,
      var220: null,
      var221: null,
      var222: null,
      var223: null,
      var224: null,
      var225: null,
      var226: null,
      var227: null,
      var228: null,
      var229: null,
      var230: null,
      var231: null,
      var232: null,
      var233: null,
      var234: null,
      var235: null,
      var236: null,
      var237: null,
      var238: null,
      var239: null,
      var240: null,
      var241: null,
      var242: null,
      var243: null,
      var244: null,
      var245: null,
      var246: null,
      var247: null,
      var248: null,
      var249: null,
      var250: null,
      playAgain: false
    }
  },
  beforeCreate: function () {
    if (!this.$store.state.fachada['telsoporte']) {
      this.$store.dispatch('fachada/getConfigGral', this.$route.params.subnet)
    }
    this.subnet = this.$route.params.subnet
  },
  async created () {
    /** Areas and Image */
    if (this.areas.length === 0) {
      // Verifica si existen en localStorage
      if (localStorage.getItem('areas')) {
        this.areas = JSON.parse(localStorage.getItem('areas'))
        // this.saveAreasVuex(JSON.parse(localStorage.getItem('areas')))
      } else {
        // Obtiene datos de la api
        await apiGrals
          .getAreas(localStorage.getItem('subnet'))
          .then(x => {
            this.areas = x.data
            localStorage.setItem('areas', JSON.stringify(x.data))
            // this.saveAreasVuex(x.data)
          })
          .catch(e => {
            // Problemas en la consulta de la api
            console.log('Problemas para cargar datos')
          })
      }
    }
    if (!localStorage.getItem('images')) {
      await apiGrals
        .getImages(localStorage.getItem('subnet'), 'all')
        .then(x => {
          localStorage.setItem('images', JSON.stringify(x.data))
          this.setImages()
        })
        .catch(e => {
          console.log('Error')
        })
    } else {
      this.setImages()
    }
    this.showtelSoporte =
      'https://wa.me/' +
      this.$store.getters['fachada/Soportetel'] +
      '?text=' +
      this.var234
    this.token = localStorage.getItem('token')
    this.titulo = localStorage.getItem('elearning')
    var decoded = jwt.verify(this.token, SECRET)
    this.formModal.nombre =
      decoded.data.nombre +
      ' ' +
      decoded.data.paterno +
      ' ' +
      decoded.data.materno
    this.formModal.correo = decoded.data.correo
    this.id = decoded.data.id
    this.formModal.sala = this.$route.params.id
    this.timecreated = new Date().getTime() / 1000
    this.getDataQues()
    this.construyeArbol(this.excelData)
    // console.log(this.excelData)
    /** Constancia */
    this.mensajeConstancia = localStorage.getItem('mensajeConstancia')
    this.constancia = localStorage.getItem('constancia') === 'true'
    // Add monitor, monitor device width and height
    window.addEventListener('resize', this.handleResize)
    this.isLoading = false
    if (localStorage.getItem('elearning')) {
      this.showElearning = true
    }
    if (localStorage.getItem('elearningmode') === 'examen') {
      this.mode = true
    }
    this.modeType = localStorage.getItem('elearningmode')
    this.pctmin = localStorage.getItem('elearningmin')
    // Variables BarProgress
    this.pctActivo = localStorage.getItem('pctActivo')
    await userActivity
      .getActividadCongresistaTiempoValido(
        this.$route.params.subnet,
        decoded.data.correo
      )
      .then(x => {
        var pct = x.data
        this.userProgress = Math.round(pct, -2)
      })
      .catch(e => {
        // Problemas en la consulta de la api
        console.log('Problemas para cargar datos' + e)
      })
    this.valueProgress = parseInt(localStorage.getItem('userValidTime'))
    this.setOptionsProgress()
    this.setMensajes()
  },
  beforeDestroy: function () {
    const swalState = swal.getState()
    if (swalState.isOpen) swal.close()
    // Destroy the monitor
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    // Filter image map areas with a not empty href
    ...mapState('fachada', [
      'urlgral',
      'telsoporte',
      'telinfo',
      'telregistro',
      'url_fachada_video',
      'img_fachada1',
      'img_fachada2',
      'timetoken',
      'elearning'
    ]),
    ...mapGetters('fachada', ['Soportetel']),
    ...mapState('users', ['modulos']),
    filteredAreas () {
      return this.areas.filter(area => {
        if (area.componente === 'elearning' && area.url !== '') {
          return area
        }
      })
    },
    isContancia () {
      return localStorage.getItem('constancia') === 'true'
    }
  },
  methods: {
    endPlayAgain () {
      this.playAgain = false
    },
    nextVideo (actualVideo) {
      if (actualVideo) {
        /** Obtener el siguiente dato con url de video */
        let nextvideo = parseInt(actualVideo)
        for (let i = nextvideo; i <= this.excelData.length; i++) {
          console.log(i)
          if (this.excelData[i].URL.indexOf('vimeo') !== -1) {
            nextvideo = i + 1
            break
          }
        }
        const button = document.getElementById(nextvideo.toString())
        const parentCollapse = button.parentElement.parentElement.parentElement
        const parentButton = parentCollapse.previousElementSibling
        const isParentOpen = parentButton.getAttribute('aria-expanded')
        if (isParentOpen === 'false') {
          this.$root.$emit('bv::toggle::collapse', parentCollapse.id)
          const grandParentCollapse = parentCollapse.parentElement.parentElement.parentElement
          if (grandParentCollapse) {
            const grandParentButton = grandParentCollapse.previousElementSibling
            const isGrandParentOpen = grandParentButton.getAttribute('aria-expanded')
            if (isGrandParentOpen === 'false') {
              this.$root.$emit('bv::toggle::collapse', grandParentCollapse.id)
            }
          }
        }
        let event = new Event('click')
        button.dispatchEvent(event)
      }
    },
    // Processing equipment width and height
    handleResize () {
      this.showSidebar = false
      // Calculate equipment width
      this.calculateFullWidth()
      // This variables are used in setting the style of .bg div
      this.curWidth = this.fullWidth + 'px'
      this.curHeight = this.fullHeight + 'px'
      // Resize image map areas
      this.filteredAreas.forEach(area => {
        // console.log(area.coords)
        area.coords = this.coordsResize(area.coords)
      })
      // Set the new equipment width
      this.previousWidth = this.fullWidth
      // Set the size of the canvas
      this.setCanvas()
    },
    // Calculate equipment width
    calculateFullWidth () {
      const img = this.$refs.background
      if (img) {
        const w = img.clientWidth
        const h = img.clientHeight
        this.fullWidth = w
        this.fullHeight = h
      }
    },
    // Calculate areas and svg's coords
    coordsResize (coords) {
      coords = coords.split(',')
      const x = this.fullWidth / this.previousWidth
      var newCoords = []
      for (let i = 0; i < coords.length; i++) {
        newCoords.push(coords[i] * x)
      }
      return newCoords.join(',')
    },
    async getDataQues () {
      this.subnet = this.$route.params.subnet
      await apiElearning
        .getData(localStorage.getItem('subnet'))
        .then(async x => {
          // console.log('Obtuve respuesta de api getData' + x.data)
          this.excelData = x.data
          this.orderTree()
          this.construyeArbol(x.data)
          await apiElearning
            .getAnswerElearning(
              localStorage.getItem('subnet'),
              this.formModal.correo
            )
            .then(y => {
              this.respuestas = y.data
              var datosRes = x.data
              datosRes.map(item => {
                if (item.TIEMPO !== '*') {
                  this.timeTotal =
                    parseInt(this.timeTotal) + parseInt(item.TIEMPO)
                }
                var id = item.id
                var ansGrales = y.data
                var finder = ansGrales.find(element => element.numPreg === id)
                if (finder) {
                  item.STATUS = false
                  this.timeAcumulado =
                    parseInt(this.timeAcumulado) + parseInt(item.TIEMPO)
                }
              })
              this.pctTime = parseInt(
                (parseInt(this.timeAcumulado) * 100) / this.timeTotal
              )
              // if(this.pctTime > 100) {
              //   this.pctTime = 100
              // }
            })
            .catch(e => {
              // Problemas en la consulta de la api
              console.log('Error al obtener respuestas')
            })
        })
        .catch(e => {
          // Problemas en la consulta de la api
          this.$router.push({
            path: localStorage.getItem('subnet') + '/mantenimiento/Elearning/'
          })
        })
    },
    nodeSelect (node, isSelected) {
      this.$emit('nodeSelect', node, isSelected)
      if (isSelected) {
        if (this.selectedNode !== null) {
          // this.selectedNode.deselect()
        }
        this.selectedNode = node
        // console.log("Select:" + node.data.name + ', ' + node.data.id)
        var idNodo = node.data.id
        this.value = this.excelData[idNodo]
        this.videoID = this.value.URL
        this.finished = false
      } else if (node === this.value) {
        this.selectedNode = null
        this.videoID = null
        this.finished = false
      }
    },
    existeRama (nombre, arreglo, nodo, isNieto) {
      var existe = arreglo.find(element => element.name === nombre)
      // console.log('Existe? ' + nombre + 'en ' + JSON.stringify(arreglo) + ' = ' + existe)
      var Rama = {
        name: 'TEMA :',
        id: null,
        children: []
      }
      var RamaN = {
        name: 'TEMA :',
        id: null
      }
      if (!existe) {
        // console.log('Inserto ' + nombre)
        if (!isNieto) {
          var NuevaRamaTema = JSON.parse(JSON.stringify(Rama))
          NuevaRamaTema.name = nombre
          NuevaRamaTema.id = nodo.id
          return NuevaRamaTema
        } else {
          var RamaNieto = JSON.parse(JSON.stringify(RamaN))
          RamaNieto.name = nombre
          RamaNieto.id = nodo.id
          // console.log('Add sin children' + JSON.stringify(RamaN))
          return RamaNieto
        }
      } else {
        return false
      }
    },
    construyeArbol (lectura) {
      // console.log('Crear Arbol Tam ExcelData' + lectura.length)
      var temas = this.Arbol
      // Step1: Revisa el nivel de TEMA
      lectura.map(item => {
        var abuelo = item.TEMA
        var rama = this.existeRama(abuelo, temas, item, false)
        if (rama) {
          this.Arbol.push(rama)
          // console.log('Insert' + JSON.stringify(rama))
        } else {
          // console.log('Existe')
        }
      })
      // Step2: Revisa el nivel de Padre
      this.Arbol.map(item => {
        // var padre = item.NIVEL1
        // console.log(JSON.stringify(item))
        var ar = item.name
        lectura.map(nodo => {
          // console.log('AR: ' + ar)
          var padre = nodo.TEMA
          var hijo = nodo.NIVEL1
          var hpadre = item.children
          if (padre === ar) {
            // console.log('PADRE: ' + padre)
            if (hijo !== '*') {
              var rama = this.existeRama(hijo, hpadre, nodo, false)
              if (rama) {
                // console.log('Insert ' + JSON.stringify(rama) + 'en ' + hijo)
                item.children.push(rama)
              }
            }
          }
        })
      })
      // Step3: Revisa el nivel de Hijo
      this.Arbol.map(item => {
        // var padre = item.NIVEL1
        // console.log(JSON.stringify(item))
        var abuelo = item.children
        abuelo.map(p => {
          // console.log(JSON.stringify(p))
          var padre = p.name
          var padreChild = p.children
          if (padre !== '*') {
            lectura.map(nodo => {
              if (nodo.TEMA === item.name) {
                if (nodo.NIVEL1 === padre) {
                  var hijo = nodo.NIVEL2
                  if (hijo !== '*') {
                    // console.log(padre + ' vs ' + nodo.NIVEL1 + 'busca: ' + hijo)
                    var rama = this.existeRama(hijo, padreChild, nodo, false)
                    if (rama) {
                      rama.id = nodo.id
                      // console.log('Insert ' + JSON.stringify(nodo) + 'en ' + hijo)
                      p.children.push(rama)
                    }
                  }
                }
              }
            })
          }
        })
      })
      // Step 4: Revisa el nivel de nieto
      this.Arbol.map(item => {
        var abuelo = item.children
        abuelo.map(p => {
          // console.log(JSON.stringify(p))
          var padre = p.name
          var padreChild = p.children
          if (padre !== '*') {
            padreChild.map(h => {
              var hijo = h.name
              var hijoChild = h.children
              // console.log(JSON.stringify(h))
              if (hijo !== '*') {
                lectura.map(nodo => {
                  if (nodo.NIVEL2 === hijo) {
                    var nieto = nodo.NIVEL3
                    if (nieto !== '*') {
                      // console.log(nieto + ' vs ' + hijo + ' busca en: ' + hijoChild)
                      var rama = this.existeRama(nieto, hijoChild, nodo, true)
                      if (rama) {
                        // console.log('Insert ' + JSON.stringify(rama) + 'en ' + hijo)
                        h.children.push(rama)
                      }
                    }
                  }
                })
              }
            })
          }
        })
      })
    },
    showModal () {
      this.modalPregunta = true
    },
    getResultado () {
      var decoded = jwt.verify(localStorage.getItem('token'), SECRET)
      var respuesta = {
        email: decoded.data.correo
      }
      apiElearning.getAnswerUser(respuesta).then(x => {
        this.ansTotal = x.data[0].total
        this.pctAns = parseInt(
          (parseInt(this.ansTotal) * 100) / this.excelData.length
        )
      })
    },
    sendQues (answer) {
      if (answer) {
        if (localStorage.getItem('token')) {
          swal({
            title: this.var235,
            text: this.var236 + '\n\n' + answer + '.',
            buttons: ['Cancelar', 'Aceptar'],
            successMode: true
          }).then(sendQues => {
            var decoded = jwt.verify(localStorage.getItem('token'), SECRET)
            var respuesta = {
              id: this.value.id,
              respuesta: answer,
              email: decoded.data.correo,
              token: localStorage.getItem('token')
            }
            if (!this.mode) {
              if (sendQues) {
                apiElearning
                  .setAnswer(localStorage.getItem('subnet'), respuesta)
                  .then(x => {
                    // console.log('1514' + JSON.stringify(x.data))
                    if (x.data[0]) {
                      if (x.data[0].status === 'Ok') {
                        swal({
                          title: this.var237,
                          text: this.var238,
                          buttons: ['Cancelar', 'Aceptar'],
                          successMode: true
                        }).then(y => {
                          this.updateData(x.data[0].total)
                        })
                      } else {
                        swal({
                          title: this.var239,
                          text: this.var240,
                          buttons: ['Cancelar', 'Aceptar'],
                          successMode: true
                        })
                      }
                    }
                    /* Bloqueo de Sesion
                    else {
                      swal({
                        // Cambiar el mensaje a variable
                        title: 'Error',
                        text: 'Se ha detectado una inconsistencia en su sesion. Debe de iniciar sesion. ',
                        buttons: true,
                        errorMode: true
                      })
                        .then(() => {
                          this.cleanToken()
                        })
                    }
                    */
                  })
                  .catch(e => {
                    // Problemas en la consulta de la api
                    console.log(e)
                  })
                this.modalPregunta = false
              }
            } else {
              // alert("Modo examen enviar respuesta")
              apiElearning
                .setAnswerExamen(localStorage.getItem('subnet'), respuesta)
                .then(x => {
                  // console.log('1562')
                  if (x.data[0]) {
                    if (x.data[0].status === 'Ok') {
                      swal({
                        title: this.var241,
                        text: this.var242,
                        buttons: true,
                        successMode: true
                      }).then(y => {
                        this.updateData(x.data[0].total)
                      })
                    }
                  } else {
                    swal({
                      title: this.var241,
                      text: this.var242,
                      buttons: ['Cancelar', 'Aceptar'],
                      successMode: true
                    }).then(y => {
                      this.updateData(x.data[0].total)
                    })
                      .then(() => {
                        this.cleanToken()
                      })
                  }
                })
                .catch(e => {
                  // Problemas en la consulta de la api
                  console.log(e)
                })
              this.modalPregunta = false
            }
          })
        }
        /* Bloqueo de Sesion
        else {
          swal({
            // Cambiar el mensaje a variable
            title: 'Error',
            text: 'Se ha detectado una inconsistencia en su sesion. Debe de iniciar sesion. ',
            buttons: true,
            errorMode: true
          })
            .then(() => {
              this.cleanToken()
            })
        }
        */
      } else {
        if (this.modeType === 'onDemand') {
          var decoded = jwt.verify(localStorage.getItem('token'), SECRET)
          var respuesta = {
            id: this.value.id,
            respuesta: 'no Ans mode onDemand',
            email: decoded.data.correo,
            token: localStorage.getItem('token')
          }
          apiElearning
            .setAnswerExamen(localStorage.getItem('subnet'), respuesta)
            .then(x => {
              // console.log('1608')
              if (x.data[0]) {
                if (x.data[0].status === 'Ok') {
                  swal({
                    title: this.var243,
                    buttons: false,
                    successMode: true
                  }).then(y => {
                    this.updateData(x.data[0].total)
                  })
                }
              }
              /* Bloqueo de sesion
              else {
                swal({
                  // Cambiar el mensaje a variable
                  title: 'Error',
                  text: 'Se ha detectado una inconsistencia en su sesion. Debe de iniciar sesion. ',
                  buttons: true,
                  errorMode: true
                })
                  .then(() => {
                    this.cleanToken()
                  })
              }
              */
            })
            .catch(e => {
              // Problemas en la consulta de la api
              console.log(e)
            })
          this.modalPregunta = false
        } else {
          swal({
            title: this.var244,
            text: this.var245,
            buttons: ['Cancelar', 'Aceptar'],
            successMode: true
          })
        }
      }
    },
    updateData (tiempo) {
      this.excelData.find(element => {
        if (element.id === this.value.id) {
          element.STATUS = false
        }
      })
      /** Bara en base a actividad de usuario */
      this.userProgress = tiempo
      this.userpct = (this.userProgress * 100) / this.valueProgress
      this.timeAcumulado =
        parseInt(this.timeAcumulado) + parseInt(this.value.TIEMPO)
      this.pctTime = parseInt(
        (parseInt(this.timeAcumulado) * 100) / this.timeTotal
      )
      this.finished = false
      // console.log('inside updateData'+ this.ansTotal + '* 100 ' + '/ ' +this.excelData.length)
      this.pctAns = parseInt(
        (parseInt(this.ansTotal) * 100) / this.excelData.length
      )
      // alert(this.pctAns)
    },
    viewTraslate () {
      this.translate = !this.translate
    },
    async setActividad (action) {
      var decoded = jwt.verify(localStorage.getItem('token'), SECRET)
      this.currentTime = new Date().getTime() / 1000
      var miTiempo = 0
      if (this.modeType !== 'onDemand') {
        miTiempo = (this.currentTime - this.timecreated) / 60
      } else {
        miTiempo = 0
      }
      this.userActividad = {
        correo: decoded.data.correo,
        token: localStorage.getItem('token'),
        modulo: 'Elearning',
        fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
        accion: 'Va a ' + action,
        duracion: miTiempo
      }
      this.localObservador.push(this.userActividad)
      if (
        this.localObservador.length > 1 ||
        action === 'salir' ||
        action === 'Lobby'
      ) {
        await userActivity
          .sendData(localStorage.getItem('subnet'), this.localObservador)
          .then(x => {
            this.setMarqueeAndStatus(x.data)
          })
      }
      this.timecreated = new Date().getTime() / 1000
    },
    // Agrega el tiempo del video a la actividadUsuarios
    async setTiempoVideo () {
      var decoded = jwt.verify(localStorage.getItem('token'), SECRET)
      this.currentTime = new Date().getTime() / 1000
      this.userActividad = {
        correo: decoded.data.correo,
        token: localStorage.getItem('token'),
        modulo: 'Elearning',
        fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
        accion: 'Adicion de Tiempo de Video ' + this.value.id,
        duracion: this.value.TIEMPO
      }
      await userActivity
        .sendData(localStorage.getItem('subnet'), [this.userActividad])
        .then(x => {
          this.setMarqueeAndStatus(x.data)
        })
      // Variables BarProgress
      this.pctActivo = localStorage.getItem('pctActivo')
      await userActivity
        .getActividadCongresistaTiempoValido(
          this.$route.params.subnet,
          decoded.data.correo
        )
        .then(x => {
          var pct = x.data
          this.userProgress = Math.round(pct, -2)
        })
        .catch(e => {
          // Problemas en la consulta de la api
          console.log('Problemas para cargar datos' + e)
        })
      this.valueProgress = parseInt(localStorage.getItem('userValidTime'))
      this.setOptionsProgress()
    },
    setMarqueeAndStatus (data) {
      this.localObservador = []
      /** Set marquee messages */
      this.$store.dispatch('users/setMarquesina', data.marquesina)
      /** Set Status components */
      localStorage.setItem('componentes', JSON.stringify(data.componentes))
      /** Closed */
      if (data.status.closed) {
        this.closedCongress('total')
      }
      if (data.status.partial) {
        this.closedCongress('partial')
      }
    },
    /** Close system */
    closedCongress (type) {
      const message = localStorage.getItem('msgCierre')
      swal({
        title: this.var246,
        text: message,
        buttons: false,
        successMode: true
      }).then(() => {
        localStorage.removeItem('token')
        this.$router.push('/' + localStorage.getItem('subnet'))
      })
    },
    goto (data, title, type, imagen) {
      // console.log('Type' + type)
      this.videoTitle = title
      if (type === 'Video') {
        this.setActividad('Ve video en Elearning' + data)
        this.videoModal = data
        this.videoShow = true
      } else if (type === 'Imagen') {
        this.setActividad('Ve imagen en Elearning ' + data)
        this.imageArea = data
        this.imageShow = true
      } else if (type === 'Pdf') {
        this.setActividad('Ve Pdf en Elearning' + data)
        // window.open(data, '_blank')
        this.pdfShow = true
        this.pdf = data
      } else if (type === 'Nav Interna') {
        // Verifica el status de Componente
        this.verificaComponente(data)
      } else if (type === 'Url') {
        this.setActividad('Ve Url en Elearning' + data)
        window.open(data, '_blank')
      }
    },
    returnLobby () {
      var shortName = 'Lobby'
      this.setActividad(shortName)
      this.timecreated = new Date().getTime() / 1000
      this.$router.push({ name: 'Lobby' })
    },
    // Filter background and buttons
    async setImages () {
      // Obtiene la lista de imagenes de localStorage
      await apiElearning
        .getImages(localStorage.getItem('subnet'), 'background')
        .then(x => {
          const image = x.data.filter(image => image.keyitem === 'elearning')
          this.background = image[0].image
        })
        .catch(e => {
          console.log('Error:')
        })
    },
    onReady (e) {
      // console.log('Video Listo', e)
      // console.log(this.$refs.videoPlayer)
      // console.log('Video Listo')
    },
    play () {
      this.$refs.player.play()

      // console.log('Inicio video')
    },
    pause () {
      this.$refs.player.pause()
    },
    endVideo () {
      this.$refs.player.pause()
      if (this.modeType === 'onDemand') {
        var decoded = jwt.verify(localStorage.getItem('token'), SECRET)
        var respuesta = {
          id: this.value.id,
          respuesta: 'no Ans mode onDemand',
          email: decoded.data.correo,
          token: localStorage.getItem('token')
        }
        apiElearning
          .setAnswerExamen(localStorage.getItem('subnet'), respuesta)
          .then(x => {
            // console.log(JSON.stringify(x.data))
            // console.log('1835')
            if (x.data[0]) {
              if (x.data[0].status === 'Ok') {
                if (this.subnet !== 'icha') {
                  swal({
                    title: this.var247,
                    text: this.var248,
                    buttons: false,
                    successMode: true
                  }).then(y => {
                    this.updateData(x.data[0].total)
                    this.setTiempoVideo()
                  })
                }
              }
            }
            /* Bloqueo de Sesion
            else {
              swal({
                // Cambiar el mensaje a variable
                title: 'Error',
                text: 'Se ha detectado una inconsistencia en su sesion. Debe de iniciar sesion. ',
                buttons: true,
                errorMode: true
              })
                .then(() => {
                  this.cleanToken()
                })
            }
            */
          })
          .catch(e => {
            // Problemas en la consulta de la api
            console.log(e)
          })
        this.modalPregunta = false
      }
      this.finished = true
    },
    /** Hover */
    setCanvas () {
      const img = this.$refs.background
      if (img) {
        const x = img.offsetLeft
        const y = img.offsetTop
        // move the canvas, so it's contained by the same parent as the image
        let imgParent = img.parentNode
        // console.log(imgParent)
        let can = document.getElementById('myCanvas')
        imgParent.appendChild(can)
        // place the canvas in front of the image
        can.style.zIndex = 1
        // position it over the image
        can.style.left = x + 'px'
        can.style.top = y + 'px'
        // make same size as the image
        can.setAttribute('width', this.fullWidth + 'px')
        can.setAttribute('height', this.fullHeight + 'px')
        // // get it's context
        this.hdc = can.getContext('2d')
        // // set the 'default' values for the colour/width of fill/stroke operations
        this.hdc.fillStyle = 'red'
        this.hdc.strokeStyle = 'red'
        this.hdc.lineWidth = 2
        document.getElementById('myCanvas').style.pointerEvents = 'none'
        this.isHidden = false
        if (this.isVertical()) {
          this.hideContent()
        }
      }
    },
    // Draw the polygon on canvas
    drawHover (event) {
      if (this.isVertical()) {
        return false
      }
      const element = event.target
      const coords = element.getAttribute('coords')
      const polyCoords = coords.split(',')
      this.hdc.beginPath()
      this.hdc.moveTo(polyCoords[0], polyCoords[1])
      for (let i = 2; i < polyCoords.length; i += 2) {
        this.hdc.lineTo(polyCoords[i], polyCoords[i + 1])
      }
      this.hdc.lineTo(polyCoords[0], polyCoords[1])
      this.hdc.shadowColor = 'red'
      this.hdc.shadowBlur = 5
      this.hdc.stroke()
    },
    // Clear the canva
    cleanHover () {
      if (this.isVertical()) {
        return false
      }
      const img = this.$refs.background
      const w = img.clientWidth
      const h = img.clientHeight
      this.hdc.clearRect(0, 0, w + 100, h + 100)
    },
    /** Hide de content on vertical device */
    hideContent () {
      this.isHidden = true
    },
    /** Verifica la orientación del dispositivo */
    isVertical () {
      return (
        document.documentElement.clientWidth < 1024 &&
        document.documentElement.clientWidth <
          document.documentElement.clientHeight
      )
    },
    gotoComponente (data) {
      var shortName = 'Contacta a Soporte Tecnico Elearning'
      this.setActividad(shortName)
      this.timecreated = new Date().getTime() / 1000
      window.open(data, '_blank')
      // }
    },
    gotoSoporteEmail () {
      var shortName = 'Contacta a Soporte Técnico - Email'
      this.setActividad(shortName)
      this.timecreated = new Date().getTime() / 1000
    },
    // Descargar constancia
    async download () {
      this.timecreated = new Date().getTime() / 1000
      const token = localStorage.getItem('token')
      var decoded = jwt.verify(localStorage.getItem('token'), SECRET)
      const name = `${decoded.data.titulo} ${decoded.data.nombre} ${decoded.data.paterno} ${decoded.data.materno}`
      let correo = `${decoded.data.correo}`
      if (token && token !== '' && correo && correo !== '') {
        const formData = new FormData()
        formData.append('name', name.trim())
        formData.append('correo', correo)
        formData.append('token', token)
        formData.append('id', this.id)
        formData.append('tiempo', this.userProgress)
        await apiGrals
          .getConstancia(this.$route.params.subnet, formData)
          .then(response => {
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.id + '.pdf'
            link.click()
          })
          .catch(e => {
            // Problemas en la consulta de la api
            console.log('Problemas para cargar datos')
          })
      } else {
        swal({
          title: 'Error',
          text:
            'Error al descargar la constancia, por favor pónganse en contacto con soporte técnico',
          buttons: false,
          successMode: true
        })
      }
    },
    selectTema (id) {
      this.playAgain = false
      this.answer = null
      this.value = null
      this.finished = false
      const data = this.excelData.find(element => {
        if (element.id === id) {
          return element
        }
      })
      this.value = data
      const Myurl = data.URL
      // this.value.URL= '41911454'
      if (Myurl !== '*') {
        this.frameURL = Myurl
        var element = this.$refs['video']
        var top = element.offsetTop
        window.scrollTo(0, top)
      } else {
        this.frameURL = 'https://player.vimeo.com/41911454'
      }
    },
    orderTree () {
      /** GrandParents */
      this.excelData.forEach(element => {
        // console.log('Element' + JSON.stringify(element))
        if (
          element.NIVEL1 === '*' &&
          element.NIVEL2 === '*' &&
          element.NIVEL2 === '*'
        ) {
          this.orderedTree.push(element)
        }
      })
      /** Parents */
      this.orderedTree.forEach(grandparent => {
        grandparent.parents = []
        this.excelData.forEach(parent => {
          if (
            grandparent.TEMA === parent.TEMA &&
            parent.NIVEL1 !== '*' &&
            parent.NIVEL2 === '*' &&
            parent.NIVEL3 === '*'
          ) {
            grandparent.parents.push(parent)
          }
        })
      })
      /** Childrens */
      this.orderedTree.forEach(grandparent => {
        grandparent.parents.forEach(parent => {
          parent.childrens = []
          this.excelData.forEach(children => {
            if (
              grandparent.TEMA === parent.TEMA &&
              parent.NIVEL1 === children.NIVEL1 &&
              children.NIVEL2 !== '*' &&
              children.NIVEL3 === '*' &&
              children.TEMA === grandparent.TEMA
            ) {
              parent.childrens.push(children)
            }
          })
        })
      })
      /** Grandchildrens */
      this.orderedTree.forEach(grandparent => {
        grandparent.parents.forEach(parent => {
          parent.childrens.forEach(children => {
            children.grandChildrens = []
            this.excelData.forEach(grandchildren => {
              if (
                grandparent.TEMA === parent.TEMA &&
                parent.NIVEL1 === children.NIVEL1 &&
                children.NIVEL2 === grandchildren.NIVEL2 &&
                grandchildren.NIVEL3 !== '*'
              ) {
                children.grandChildrens.push(grandchildren)
              }
            })
          })
        })
      })
    },
    verificaComponente (data) {
      var datos = data.split('/')
      var modulo = datos[2]
      const shortName = 'Va a ' + data
      this.componentes = JSON.parse(localStorage.getItem('componentes'))
      // Ajuste de busqueda de salas
      if (modulo === 'sala') {
        modulo = 'salas'
      }
      const existe = this.componentes.find(element => {
        if (element.nombreComponente === modulo) {
          return element
        }
      })
      if (existe.status === 'true') {
        this.setActividad(shortName)
        this.$router.push({ path: data })
      } else {
        // Cambio de nombre de tl
        if (modulo === 'tl') {
          modulo = 'Trabajos Libres'
        }
        swal({
          title: this.var249,
          text: modulo + ',' + this.var250,
          buttons: false,
          successMode: true
        })
      }
    },
    setOptionsProgress () {
      this.userpct = (this.userProgress * 100) / this.valueProgress
      if (this.userpct <= 30) {
        // set color rojo
        this.colorBar = 'danger'
      }
      if (this.userpct > 41 && this.userpct <= this.pctActivo) {
        // set color naranja
        this.colorBar = 'warning'
      }
      if (this.userpct > this.pctActivo) {
        // set color verde
        this.colorBar = 'success'
      }
      this.userpct = Math.round(this.userpct, -2)
      if (this.userpct < 0) {
        this.userpct = 0
      }
      if (this.userpct > 100) {
        this.userpct = 100
      }
    },
    async setMensajes () {
      // Obtiene datos de los mensajes desde API
      this.subnet = this.$route.params.subnet
      await apiGrals
        .getMensajes(this.subnet, 'Elearning')
        .then(x => {
          this.mensajes = x.data
        })
        .catch(e => {
          // Problemas en la consulta de la api
          this.$router.push({
            path: '/ErrorSubnet/' + localStorage.getItem('subnet')
          })
        })
      this.var196 = this.mensajes[0].valor
      this.var197 = this.mensajes[1].valor
      this.var198 = this.mensajes[2].valor
      this.var199 = this.mensajes[3].valor
      this.var200 = this.mensajes[4].valor
      this.var201 = this.mensajes[5].valor
      this.var202 = this.mensajes[6].valor
      this.var203 = this.mensajes[7].valor
      this.var204 = this.mensajes[8].valor
      this.var205 = this.mensajes[9].valor
      this.var206 = this.mensajes[10].valor
      this.var207 = this.mensajes[11].valor
      this.var208 = this.mensajes[12].valor
      this.var209 = this.mensajes[13].valor
      this.var210 = this.mensajes[14].valor
      this.var211 = this.mensajes[15].valor
      this.var212 = this.mensajes[16].valor
      this.var213 = this.mensajes[17].valor
      this.var214 = this.mensajes[18].valor
      this.var215 = this.mensajes[19].valor
      this.var216 = this.mensajes[20].valor
      this.var217 = this.mensajes[21].valor
      this.var218 = this.mensajes[22].valor
      this.var219 = this.mensajes[23].valor
      this.var220 = this.mensajes[24].valor
      this.var221 = this.mensajes[25].valor
      this.var222 = this.mensajes[26].valor
      this.var223 = this.mensajes[27].valor
      this.var224 = this.mensajes[28].valor
      this.var225 = this.mensajes[29].valor
      this.var226 = this.mensajes[30].valor
      this.var227 = this.mensajes[31].valor
      this.var228 = this.mensajes[32].valor
      this.var229 = this.mensajes[33].valor
      this.var230 = this.mensajes[34].valor
      this.var231 = this.mensajes[35].valor
      this.var232 = this.mensajes[36].valor
      this.var233 = this.mensajes[37].valor
      this.var234 = this.mensajes[38].valor
      this.var235 = this.mensajes[39].valor
      this.var236 = this.mensajes[40].valor
      this.var237 = this.mensajes[41].valor
      this.var238 = this.mensajes[42].valor
      this.var239 = this.mensajes[43].valor
      this.var240 = this.mensajes[44].valor
      this.var241 = this.mensajes[45].valor
      this.var242 = this.mensajes[46].valor
      this.var243 = this.mensajes[47].valor
      this.var244 = this.mensajes[48].valor
      this.var245 = this.mensajes[49].valor
      this.var246 = this.mensajes[50].valor
      this.var247 = this.mensajes[51].valor
      this.var248 = this.mensajes[52].valor
      this.var249 = this.mensajes[53].valor
      this.var250 = this.mensajes[54].valor
    },
    async cleanToken () {
      await apiLogin
        .deleteTokenSesion({email: sessionStorage.getItem('email'), token: localStorage.getItem('token')})
        .then(x => {
          localStorage.removeItem('token')
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('email')
          this.$router.push('/' + localStorage.getItem('subnet'))
        })
    }
  }
}
</script>

<style scope>
.actions {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
  align-items: center;
}
.side-navbar, .main {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Elearning.vue